import LogService from "@/core/services/logService";

export default ({}: any, inject: any) => {
  inject("log", new LogService());
};
